import { type ReactElement } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Tooltip } from '@mui/material'
import { formatKn } from '../utils'
import { CharacteristicSupportReactionRangeRow } from './CharacteristicSupportReactionRangeRow'

interface Range {
  forceMin: number
  forceMax: number
  minLoadedFields: string[]
  maxLoadedFields: string[]
  positionedFields: string[]
}

interface Props {
  force?: number
  range?: Range
}

const loadedFieldsText = (loadedFields: string[], positionedFields: string[]) =>
  loadedFields.length === positionedFields.length
    ? `${loadedFields.join(', ')} (Volllast)`
    : loadedFields.join(', ')

/** Full-load reaction, with its min/max over the decisive load positioning below and an
 * info icon naming the loaded fields of both. */
export const CharacteristicSupportReactionCell = ({ force, range }: Props): ReactElement => {
  if (force === undefined || Number.isNaN(force)) return <Box>—</Box>

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {formatKn(force)}
        {range ? (
          <Tooltip
            title={
              <>
                <Box sx={{ fontWeight: 500 }}>Belastete Felder</Box>
                <Box>min.: {loadedFieldsText(range.minLoadedFields, range.positionedFields)}</Box>
                <Box>max.: {loadedFieldsText(range.maxLoadedFields, range.positionedFields)}</Box>
              </>
            }
            arrow
            disableInteractive
            placement="top"
          >
            <InfoOutlinedIcon
              sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }}
              data-cy="characteristic-support-reaction-positioning-info"
            />
          </Tooltip>
        ) : null}
      </Box>
      {range ? (
        <>
          <CharacteristicSupportReactionRangeRow label="min.:" force={range.forceMin} />
          <CharacteristicSupportReactionRangeRow label="max.:" force={range.forceMax} />
        </>
      ) : null}
    </Box>
  )
}
